import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(r.data.role === "admin" ? "/admin" : "/account", {
          replace: true,
          state: { user: r.data },
        });
      } catch (err) {
        console.warn("Session exchange failed", err);
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-brand-ink flex items-center justify-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-white/70">
        <Loader2 className="w-5 h-5 animate-spin text-brand-orange" />
        <span className="font-mono text-sm">Signing you in…</span>
      </div>
    </div>
  );
};
